var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedalLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.4533,
    cy: 70.3727,
    r: 69.7345,
    fill: "#E6F0EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.4552 82.5068L96.7903 104.513L84.9851 98.9315L80.7827 111.282L70.4531 86.9338",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4552 82.5068L96.7903 104.513L84.9851 98.9315L80.7827 111.282L70.4531 86.9338",
    stroke: "#135040",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4524 86.9338L60.1228 111.282L55.9204 98.9315L44.1152 104.513L53.4503 82.5068",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4524 86.9338L60.1228 111.282L55.9204 98.9315L44.1152 104.513L53.4503 82.5068",
    stroke: "#135040",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7582 34.0029C76.6133 32.5272 80.1099 33.4896 81.8422 36.1842C82.9329 37.8845 84.7614 38.9431 86.7824 39.0393C89.9904 39.1997 92.5567 41.7661 92.7171 44.974C92.8134 46.995 93.872 48.8235 95.5722 49.9142C98.2669 51.6465 99.1972 55.1432 97.7536 57.9982C96.8233 59.7947 96.8233 61.9119 97.7536 63.6763C99.2292 66.5313 98.2669 70.028 95.5722 71.7603C93.872 72.851 92.8134 74.6795 92.7171 76.7005C92.5567 79.9084 89.9904 82.4748 86.7824 82.6352C84.7614 82.7314 82.9329 83.79 81.8422 85.4902C80.1099 88.1849 76.6133 89.1152 73.7582 87.6716C71.9618 86.7413 69.8445 86.7413 68.0802 87.6716C65.2251 89.1473 61.7285 88.1849 59.9962 85.4902C58.9055 83.79 57.077 82.7314 55.056 82.6352C51.848 82.4748 49.2817 79.9084 49.1213 76.7005C49.025 74.6795 47.9664 72.851 46.2662 71.7603C43.5715 69.9959 42.6412 66.4992 44.0848 63.6763C45.0151 61.8798 45.0151 59.7626 44.0848 57.9982C42.6412 55.1111 43.5715 51.6144 46.2662 49.8821C47.9664 48.7914 49.025 46.9629 49.1213 44.9419C49.2817 41.734 51.848 39.1676 55.056 39.0072C57.077 38.911 58.9055 37.8524 59.9962 36.1522C61.6964 33.4896 65.193 32.5593 68.0481 34.0029C69.8445 34.9332 71.9618 34.9332 73.7582 34.0029Z",
    fill: "white",
    stroke: "#135040",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0667 48.3425C69.2017 45.4874 61.2781 48.7595 58.423 55.6245C55.568 62.4895 58.8401 70.4131 65.705 73.2681C72.57 76.1232 80.4936 72.8511 83.3487 65.9861C86.2038 59.1211 82.9317 51.1975 76.0667 48.3425ZM79.018 56.0094L69.4262 67.4618C69.2658 67.6542 69.0413 67.7826 68.7847 67.7826C68.7526 67.7826 68.7526 67.7826 68.7205 67.7826C68.4959 67.7826 68.2714 67.6863 68.111 67.558L62.6575 62.6178C62.2725 62.297 62.2405 61.7196 62.5933 61.3346C62.9141 60.9496 63.4916 60.9176 63.8765 61.2704L68.6563 65.5691L77.6386 54.8546C77.9594 54.4696 78.5368 54.4055 78.9217 54.7262C79.3067 55.047 79.3388 55.6245 79.018 56.0094Z",
    fill: "#135040"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalLogo);
export default __webpack_public_path__ + "static/media/medal-logo.1599678bc83205c50cc52ad1e4ea8e31.svg";
export { ForwardRef as ReactComponent };